import { Action } from '@ngrx/store';
import { ConsumptionInterface } from '../../models/consumption.interface';

export enum EConsumptionActions {
  GetConsumption = '[CONSUMPTION] Get consumption',
  GetConsumptionSuccess = '[CONSUMPTION] Get consumption success',
  GetConsumptionFailure = '[CONSUMPTION] Get consumption failure'
}

export class GetConsumption implements Action {
  public readonly type = EConsumptionActions.GetConsumption;
  constructor(public phoneNumber: string) {}
}

export class GetConsumptionSuccess implements Action {
  public readonly type = EConsumptionActions.GetConsumptionSuccess;
  constructor(public payload: ConsumptionInterface) {}
}

export class GetConsumptionFailure implements Action {
  public readonly type = EConsumptionActions.GetConsumptionFailure;
}

export type ConsumptionActions = GetConsumption | GetConsumptionSuccess | GetConsumptionFailure;
